import type { accountMenu as en } from '@/i18n/locales/en/accountMenu';
import type { Translation } from '@/i18n/types';

export const accountMenu: Translation<typeof en> = {
  trigger: 'Konto',
  viewProfile: 'Profil ansehen',
  roles: {
    admin: 'Plattform-Administrator',
    companyAdmin: 'Unternehmens-Administrator',
    departmentAdmin: 'Abteilungs-Administrator/Coach',
  },
  company: {
    label: 'Unternehmen',
    switchTo: 'Zu {{name}} wechseln',
  },
  accounts: {
    label: 'Andere Konten',
    switchTo: 'Zu {{name}} wechseln',
    addAnother: 'Mit einem anderen Konto anmelden',
  },
  manage: 'Verwaltung',
  settings: 'Unternehmensprofil',
  language: 'Sprache',
  theme: {
    label: 'Thema',
    light: 'Hell',
    dark: 'Dunkel',
    system: 'System',
  },
  signOut: 'Abmelden',
  signOutAll: 'Von allen Konten abmelden',
};
